module.exports = __webpack_public_path__ + "img/芒果6.1acfb391.png";